var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-modals"},[_vm._l((_vm.modals),function({ modalName, Component, props }){return [_c(Component,_vm._b({key:modalName,tag:"component"},'component',{ modalName, ...props },false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }